'use client';

import { getMediaMimeType, Media } from '@/frontend/components/ui/media';
import { Media as MediaType, MediaBannerComponent as MediaBannerComponentType } from '@/payload-types';
import { CTAArray } from '@/frontend/components/ui/content/cta-elements';
import { checkHeadlineForSpecialChars } from '@/frontend/utils/headlineChars';
import { GradientBlur } from '@/frontend/components/ui/common/gradiant-blur';
import './styles.scss';
import { ButtonContainer } from '../../ui/button';
import { useRef } from 'react';
import { useInView } from 'motion/react';
import clsx from 'clsx';

const MediaBannerContent = ({ content }: { content: MediaBannerComponentType}) => {
  const mediaContent = getMediaMimeType(content?.mediaGroup?.media as MediaType);
  const ctaArray = content?.bannerTextGroup?.ctaArray;
  const containerRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, {
    once: true,
    amount: 0.5,
  });

  return (
    <div className={clsx('media-banner-wrapper', isInView && 'in-view')} ref={containerRef}>
      <Media mediaGroup={content.mediaGroup} type={mediaContent} showDescription={content.mediaGroup?.showDescription} quality={75} sizeLayout="squareBig" artDirection={true} />
      <GradientBlur direction="bottom" />
      <div className='media-banner-content'>
        { content?.bannerTextGroup?.heading && <h2>{checkHeadlineForSpecialChars(content.bannerTextGroup.heading)}</h2> }
        { ctaArray?.length ? (
          <ButtonContainer alignment="center">
            <CTAArray ctaArray={ctaArray} />
          </ButtonContainer>
        ): null }
      </div>
    </div>
  );
};
MediaBannerContent.displayName = 'MediaBannerContent';

export default MediaBannerContent;